/**
 * Infraestrutura Module Routes
 * Stories: 14.2, 14.4
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const InfraDeploy = lazy(() => import("@/pages/infra/Deploy"));
const BackupDashboard = lazy(() => import("@/pages/infraestrutura/BackupDashboard"));
const RunbooksPage = lazy(() => import("@/pages/infraestrutura/RunbooksPage"));
const RunbooksDashboardPage = lazy(() => import("@/pages/infraestrutura/RunbooksDashboardPage"));
const RunbookEditorPage = lazy(() => import("@/pages/infraestrutura/RunbookEditorPage"));
const RunbookDetailPage = lazy(() => import("@/pages/infraestrutura/RunbookDetailPage"));

export const infraestruturaRoutes: ModuleRoutes = {
  moduleId: "infraestrutura",
  basePath: "/infraestrutura",
  routes: [
    {
      path: "/infraestrutura/deploy",
      element: <InfraDeploy />,
      permission: { resource: "infraestrutura", action: "deploy_view" },
    },
    {
      path: "/infraestrutura/backups",
      element: <BackupDashboard />,
      permission: { resource: "backup", action: "view" },
    },
    {
      path: "/infraestrutura/runbooks",
      element: <RunbooksPage />,
      permission: { resource: "runbook", action: "view" },
    },
    {
      path: "/infraestrutura/runbooks/dashboard",
      element: <RunbooksDashboardPage />,
      permission: { resource: "runbook", action: "view" },
    },
    {
      path: "/infraestrutura/runbooks/new",
      element: <RunbookEditorPage />,
      permission: { resource: "runbook", action: "create" },
    },
    {
      path: "/infraestrutura/runbooks/:id",
      element: <RunbookDetailPage />,
      permission: { resource: "runbook", action: "view" },
    },
    {
      path: "/infraestrutura/runbooks/:id/edit",
      element: <RunbookEditorPage />,
      permission: { resource: "runbook", action: "update" },
    },
  ],
};
